import React from 'react';
import { List, Avatar, Space, Button } from 'antd';
import { BankOutlined, LikeOutlined, MessageOutlined, UserAddOutlined, UserOutlined } from '@ant-design/icons';
import { IconTextProps, DataItem, PageSetting } from '../..';

const IconText: React.FC<IconTextProps> = ({ icon: Icon, text }) => (
    <Space>
        {React.createElement(Icon)}
        {text}
    </Space>
);

interface Props {
    totalPages?: number;
    onPaginationChanged: (page: number) => void;
    onConnect: (contact: any) => void;
    data: DataItem[];
}
const RecomendationCapacitiesList: React.FC<Props> = ({ data, onConnect, onPaginationChanged, totalPages }) => {
    console.log("data capacities", data)
    return (
        <List
            itemLayout="vertical"
            size="large"
            pagination={{
                simple: true,
                total: totalPages,
                onChange: (page) => {
                    onPaginationChanged(page)
                },
                pageSize: PageSetting.limit,
            }}
            dataSource={data}
            renderItem={(item: DataItem) => (
                <>
                    <List.Item
                        key={item.title}
                        actions={[
                            <Button
                                type='link'
                                style={{ color: "#F37221", fontWeight: "bolder" }}
                                icon={<UserAddOutlined />}
                                onClick={() => onConnect(item)}
                                size={'small'}>Conectar</Button>
                        ]}
                    >
                        <List.Item.Meta
                            avatar={<Avatar icon={item.description === "Empresas" ? (<UserOutlined />) : (<BankOutlined />)} />}
                            title={<a href={item.href}>{item.title}</a>}
                            description={item.description}
                        />
                        {item.content}
                    </List.Item>
                </>
            )}
        />
    );
}


export default RecomendationCapacitiesList;